// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"a7","header":"a8","body":"a9","buttonRow":"a-","buttonWrapper":"a_","button":"ba","error":"bb"};